import { styled } from '@/shared/styles/theme'

export const Container = styled('div', {
  '& > form > div:first-child': {
    minHeight: 'calc(100dvh - 160px)',
    height: 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '$3',

    '& > *': {
      width: '100%',
      maxWidth: '640px',
    },

    fieldset: {
      border: 'none',
      padding: 0,
    },

    '@md': {
      minHeight: 'calc(100dvh - 80px)',
      height: 'fit-content',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
})

export const FormInfoContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
})
